<template>
  <div :key="member.id">
    <router-view />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
    computed: {
        ...mapGetters([
            'member',
        ]),
    },
    async beforeRouteUpdate(to, from, next) {
        if (from.params.memberId !== to.params.memberId) {
            if (await this.getMemberInfo(to.params.memberId)) {
                next();
            }
        } else {
            next();
        }
    },
    methods: {
        ...mapActions({
            getMemberInfo: 'getMemberInfo',
        }),
    },
};
</script>
